import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HotCallStatusService } from '../common/services/hot-call-status.service';

@Component({
  selector: 'app-create-new-hot-call',
  templateUrl: './create-new-hot-call.component.html',
  styleUrl: './create-new-hot-call.component.css'
})
export class CreateNewHotCallComponent implements OnInit {
  partFormGroup: FormGroup;
  runOutFormGroup: FormGroup;
  conveyanceFormGroup: FormGroup;
  wrapUpFormGroup: FormGroup;
  isLinear: boolean;
  currentSection: number;
  showLineDetails: boolean = false;
  constructor(private fb: FormBuilder, private readonly router: Router, private readonly hotCallStatusService: HotCallStatusService) {
    this.partFormGroup = this.fb.group({
    });

    this.runOutFormGroup = this.fb.group({
    });

    this.conveyanceFormGroup = this.fb.group({
    });

    this.wrapUpFormGroup = this.fb.group({
    });
    this.isLinear = false;
  }
  ngOnInit(): void {
    const hotCallAvailability = this.hotCallStatusService.getData();
    this.currentSection = (hotCallAvailability === 'new') ? 1 : 3;
  }

  public gotoHome(): void {
    this.router.navigate(['home']);
  }


}